import React, { FC, useState, useRef } from "react"
import { Props } from "./types"
import * as styles from "./styles.module.scss"
import Add from "src/components/Icons/Add"
import Hide from "src/components/Icons/Hide"

const Accordion: FC<Props> = ({ title, content }) => {
  const [active, setActive] = useState(false)

  const contentRef = useRef<HTMLDivElement>(null)

  //function toggleAccordion() {
  //  setActive(!active)
  //}
  const height = active
    ? `${contentRef.current ? contentRef.current.scrollHeight : 0}px`
    : "0px"
  return (
    <div className={styles.accordion__section}>
      {active ? (
        <div className={`${styles.accordion} ${active ? styles.active : ""}`}>
          <h5 className={styles.accordion__title}>{title}</h5>
          <button
            className={styles.accordion__icon}
            onClick={() => setActive(false)}
          >
            <Hide />
          </button>
        </div>
      ) : (
        <button
          className={`${styles.accordion} ${active ? styles.active : ""}`}
          onClick={() => setActive(true)}
        >
          <h5 className={styles.accordion__title}>{title}</h5>
          <div className={styles.accordion__icon}>
            <Add />
          </div>
        </button>
      )}

      <div
        ref={contentRef}
        style={{ maxHeight: `${height}` }}
        className={styles.accordion__content}
      >
        <div
          className={styles.accordion__text}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  )
}

export default Accordion
